import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ValidationService } from '../../../services/validation-service/validation.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: './basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;
  
  public mfData? : object = {};
  public courts?;
  public owners?;
  public facilities?;
  isUpdate: boolean = false;
  dbFunction?: string;
  ownerId: string;
  facilityId: string;
  countryCode: string;
  nameEn: string;
  nameAr: string;
  cityEn: string;
  cityAr: string;
  longitude: string;
  latitude: string;
  startTime;
  endTime;
  ccy: string;
  water: string;
  rackets: string;
  balls: string;
  indoor: string;
  bibs: string;
  toilets: string;
  showers: string;
  outdoor: string;
  private: string;
  recording: string;
  wifi: string;
  ladiesOnly: string;
  taxPercentage: string;
  isNew: string;
  isBusy: string;
  isOffer: string;
  isClosed: string;
  timeslot30min: string;
  timeslot60min: string;
  timeslot90min: string;
  timeslot120min: string;
  gracePeriodInMonths: string;
  onboardingDate: string;
  callContactNumber: string;
  whatsappContactNumber: string;
  facilityIBAN: string;
  allowedBookingInDays: string;
  allowedSplitPayment: string;
  cancelBookingBeforeInHours: string;
  officialName: string;
  taxNumber: string;
  taxOnus: string;
  logoUrl: string;
  pageUrl: string;
  uniqueCode: string;
  showInApp: string;
  inArena: string;
  fixedPlace: string;
  extraDetails: string;
  extraDetailsAr: string;
  cardPayment: string;
  subscriptionFee: string;
  sort: string;
  log_date: string;
  status: string;
  testSecretKey: string;
  testPublicKey: string;
  liveSecretKey: string;
  livePublicKey: string;
  public isLoading = false;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv : ValidationService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.dbFunction = 'updateOwnersTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.facilityId = this.mfData['id'];
      this.ownerId = this.mfData['ownerId'];
      this.countryCode = this.mfData['countryCode'];
      this.nameEn = this.mfData['nameEn'];
      this.nameAr = this.mfData['nameAr'];
      this.cityEn = this.mfData['cityEn'];
      this.cityAr = this.mfData['cityAr'];
      this.longitude = this.mfData['longitude'];
      this.latitude = this.mfData['latitude'];
      this.startTime = this.mfData['startTime'] != null ? new Date("2022/01/01" + " " + this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];
      this.endTime = this.mfData['endTime'] != null ? new Date("2022/01/01" + " " + this.mfData['endTime'].replace(/-/g, "/")) : this.mfData['endTime'];
      this.ccy = this.mfData['ccy'];
      this.water = this.mfData['water'];
      this.rackets = this.mfData['rackets'];
      this.balls = this.mfData['balls'];
      this.indoor = this.mfData['indoor'];
      this.bibs = this.mfData['bibs'];
      this.toilets = this.mfData['toilets'];
      this.showers = this.mfData['showers'];
      this.outdoor = this.mfData['outdoor'];
      this.private = this.mfData['private'];
      this.recording = this.mfData['recording'];
      this.wifi = this.mfData['wifi'];
      this.ladiesOnly = this.mfData['ladiesOnly'];
      this.taxPercentage = this.mfData['taxPercentage'];
      this.isNew = this.mfData['isNew'];
      this.isBusy = this.mfData['isBusy'];
      this.isOffer = this.mfData['isOffer'];
      this.isClosed = this.mfData['isClosed'];
      this.timeslot30min = this.mfData['timeslot30min'];
      this.timeslot60min = this.mfData['timeslot60min'];
      this.timeslot90min = this.mfData['timeslot90min'];
      this.timeslot120min = this.mfData['timeslot120min'];
      this.onboardingDate = this.mfData['onboardingDate'] != null ? new Date(this.mfData['onboardingDate'].replace(/-/g, "/")) : this.mfData['onboardingDate'];
      this.gracePeriodInMonths = this.mfData['gracePeriodInMonths'];
      this.callContactNumber = this.mfData['callContactNumber'];
      this.whatsappContactNumber = this.mfData['whatsappContactNumber'];
      this.facilityIBAN = this.mfData['facilityIBAN'];
      this.allowedBookingInDays = this.mfData['allowedBookingInDays'];
      this.allowedSplitPayment = this.mfData['allowedSplitPayment'];
      this.cancelBookingBeforeInHours = this.mfData['cancelBookingBeforeInHours'];
      this.officialName = this.mfData['officialName'];
      this.taxNumber = this.mfData['taxNumber'];
      this.taxOnus = this.mfData['taxOnus'];
      this.logoUrl = this.mfData['logoUrl'];
      this.pageUrl = this.mfData['pageUrl'];
      this.uniqueCode = this.mfData['uniqueCode'];
      this.showInApp = this.mfData['showInApp'];
      this.inArena = this.mfData['inArena'];
      this.fixedPlace = this.mfData['fixedPlace'];
      this.extraDetails = this.mfData['extraDetails'];
      this.extraDetailsAr = this.mfData['extraDetailsAr'];
      this.cardPayment = this.mfData['cardPayment'];
      this.subscriptionFee = this.mfData['subscriptionFee'];
      this.sort = this.mfData['sort'];
      this.log_date = this.mfData['log_date'];
      this.status = this.mfData['status'];
      this.testSecretKey = this.mfData['testSecretKey'];
      this.testPublicKey = this.mfData['testPublicKey'];
      this.liveSecretKey = this.mfData['liveSecretKey'];
      this.livePublicKey = this.mfData['livePublicKey'];
    }
    else
    {
      this.dbFunction = '/addBooking';
      this.facilityId = '';
      this.ownerId = '';
      this.countryCode = '';
      this.nameEn = '';
      this.nameAr = '';
      this.cityEn = '';
      this.cityAr = '';
      this.longitude = '';
      this.latitude = '';
      this.startTime = '';
      this.endTime = '';
      this.ccy = '';
      this.water = '';
      this.rackets = '';
      this.balls = '';
      this.indoor = '';
      this.bibs = '';
      this.toilets = '';
      this.showers = '';
      this.outdoor = '';
      this.private = '';
      this.recording = '';
      this.wifi = '';
      this.ladiesOnly = '';
      this.taxPercentage = '';
      this.isNew = '';
      this.isBusy = '';
      this.isOffer = '';
      this.isClosed = '';
      this.timeslot30min = '';
      this.timeslot60min = '';
      this.timeslot90min = '';
      this.timeslot120min = '';
      this.onboardingDate = '';
      this.gracePeriodInMonths = '';
      this.callContactNumber = '';
      this.whatsappContactNumber = '';
      this.facilityIBAN = '';
      this.allowedBookingInDays = '';
      this.allowedSplitPayment = '';
      this.cancelBookingBeforeInHours = '';
      this.officialName = '';
      this.taxNumber = '';
      this.taxOnus = '';
      this.logoUrl = '';
      this.pageUrl = '';
      this.uniqueCode = '';
      this.showInApp = '';
      this.inArena = '';
      this.fixedPlace = '';
      this.extraDetails = '';
      this.extraDetailsAr = '';
      this.cardPayment = '';
      this.subscriptionFee = '';
      this.sort = '';
      this.log_date = '';
      this.status = '';
      this.testSecretKey = '';
      this.testPublicKey = '';
      this.liveSecretKey = '';
      this.livePublicKey = '';
    }
    // this.loadActiveUsers();
    // this.loadActiveFacilities();
    // this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        await this.loadOwners();
        await this.createForm();
      });
    });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      ownerId: [this.ownerId, [Validators.required]],
      facilityId: {value: this.facilityId, disabled: true },
      countryCode: [this.countryCode, [Validators.required]],
      nameEn: [this.nameEn, [Validators.required]],
      nameAr: [this.nameAr, [Validators.required]],
      cityEn: [this.cityEn, [Validators.required]],
      cityAr: [this.cityAr, [Validators.required]],
      longitude: [this.longitude, [Validators.required]],
      latitude: [this.latitude, [Validators.required]],
      startTime: [this.startTime],
      endTime: [this.endTime],
      ccy: [this.ccy, [Validators.required]],
      water: [this.water, [Validators.required]],
      rackets: [this.rackets, [Validators.required]],
      balls: [this.balls, [Validators.required]],
      indoor: [this.indoor, [Validators.required]],
      bibs: [this.bibs, [Validators.required]],
      toilets: [this.toilets, [Validators.required]],
      showers: [this.showers, [Validators.required]],
      outdoor: [this.outdoor, [Validators.required]],
      private: [this.private, [Validators.required]],
      recording: [this.recording, [Validators.required]],
      wifi: [this.wifi, [Validators.required]],
      ladiesOnly: [this.ladiesOnly, [Validators.required]],
      taxPercentage: [this.taxPercentage, [Validators.required]],
      isNew: [this.isNew, [Validators.required]],
      isBusy: [this.isBusy, [Validators.required]],
      isOffer: [this.isOffer, [Validators.required]],
      isClosed: [this.isClosed, [Validators.required]],
      timeslot30min: [this.timeslot30min, [Validators.required]],
      timeslot60min: [this.timeslot60min, [Validators.required]],
      timeslot90min: [this.timeslot90min, [Validators.required]],
      timeslot120min: [this.timeslot120min, [Validators.required]],
      onboardingDate: [this.onboardingDate, [Validators.required]],
      gracePeriodInMonths: [this.gracePeriodInMonths, [Validators.required]],
      callContactNumber: [this.callContactNumber, [Validators.required]],
      whatsappContactNumber: [this.whatsappContactNumber, [Validators.required]],
      facilityIBAN: [this.facilityIBAN, [Validators.required]],
      allowedBookingInDays: [this.allowedBookingInDays, [Validators.required]],
      allowedSplitPayment: [this.allowedSplitPayment, [Validators.required]],
      cancelBookingBeforeInHours: [this.cancelBookingBeforeInHours, [Validators.required]],
      officialName: [this.officialName, [Validators.required]],
      taxNumber: [this.taxNumber, [Validators.required]],
      taxOnus: [this.taxOnus, [Validators.required]],
      logoUrl: [this.logoUrl, [Validators.required]],
      pageUrl: [this.pageUrl, [Validators.required]],
      uniqueCode: [this.uniqueCode, [Validators.required]],
      showInApp: [this.showInApp, [Validators.required]],
      inArena: [this.inArena, [Validators.required]],
      fixedPlace: [this.fixedPlace, [Validators.required]],
      extraDetails: [this.extraDetails, [Validators.required]],
      extraDetailsAr: [this.extraDetailsAr, [Validators.required]],
      cardPayment: [this.cardPayment, [Validators.required]],
      subscriptionFee: [this.subscriptionFee, [Validators.required]],
      sort: [this.sort, [Validators.required]],
      log_date: [this.log_date, [Validators.required]],
      status: [this.status, [Validators.required]],
      testSecretKey: [this.testSecretKey, [Validators.required]],
      testPublicKey: [this.testPublicKey, [Validators.required]],
      liveSecretKey: [this.liveSecretKey, [Validators.required]],
      livePublicKey: [this.livePublicKey, [Validators.required]]
    }, { });
    this.isLoading = false;
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}

saveFacility = () => {
  var startTime = moment(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : null).format("HH:mm");
  var endTime = moment(this.simpleForm.controls['endTime'] ? this.f['endTime'].value : null).format("HH:mm");
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    const fields = {
      facilityId: this.facilityId,
      ownerId: this.f['ownerId'].value,
      countryCode: this.f['countryCode'].value,
      nameEn: this.f['nameEn'].value,
      nameAr: this.f['nameAr'].value,
      cityEn: this.f['cityEn'].value,
      cityAr: this.f['cityAr'].value,
      longitude: this.f['longitude'].value,
      latitude: this.f['latitude'].value,
      startTime: startTime,
      endTime: endTime,
      ccy: this.f['ccy'].value,
      water: this.f['water'].value,
      rackets: this.f['rackets'].value,
      balls: this.f['balls'].value,
      indoor: this.f['indoor'].value,
      bibs: this.f['bibs'].value,
      toilets: this.f['toilets'].value,
      showers: this.f['showers'].value,
      outdoor: this.f['outdoor'].value,
      private: this.f['private'].value,
      recording: this.f['recording'].value,
      wifi: this.f['wifi'].value,
      ladiesOnly: this.f['ladiesOnly'].value,
      taxPercentage: this.f['taxPercentage'].value,
      isNew: this.f['isNew'].value,
      isBusy: this.f['isBusy'].value,
      isOffer: this.f['isOffer'].value,
      isClosed: this.f['isClosed'].value,
      timeslot30min: this.f['timeslot30min'].value,
      timeslot60min: this.f['timeslot60min'].value,
      timeslot90min: this.f['timeslot90min'].value,
      timeslot120min: this.f['timeslot120min'].value,
      onboardingDate: this.f['onboardingDate'].value,
      gracePeriodInMonths: this.f['gracePeriodInMonths'].value,
      callContactNumber: this.f['callContactNumber'].value,
      whatsappContactNumber: this.f['whatsappContactNumber'].value,
      facilityIBAN: this.f['facilityIBAN'].value,
      allowedBookingInDays: this.f['allowedBookingInDays'].value,
      allowedSplitPayment: this.f['allowedSplitPayment'].value,
      cancelBookingBeforeInHours: this.f['cancelBookingBeforeInHours'].value,
      officialName: this.f['officialName'].value,
      taxNumber: this.f['taxNumber'].value,
      taxOnus: this.f['taxOnus'].value,
      logoUrl: this.f['logoUrl'].value,
      pageUrl: this.f['pageUrl'].value,
      uniqueCode: this.f['uniqueCode'].value,
      showInApp: this.f['showInApp'].value,
      inArena: this.f['inArena'].value,
      fixedPlace: this.f['fixedPlace'].value,
      extraDetails: this.f['extraDetails'].value,
      extraDetailsAr: this.f['extraDetailsAr'].value,
      cardPayment: this.f['cardPayment'].value,
      subscriptionFee: this.f['subscriptionFee'].value,
      sort: this.f['sort'].value,
      log_date: this.f['log_date'].value,
      status: this.f['status'].value,
      testSecretKey: this.f['testSecretKey'].value,
      testPublicKey: this.f['testPublicKey'].value,
      liveSecretKey: this.f['liveSecretKey'].value,
      livePublicKey: this.f['livePublicKey'].value
    }
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateFacility(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Facility Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addFacility(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Facility Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  loadOwners = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getOwnersList()
      .then(res => {
        this.owners = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }

}
